import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/tg-icon.png")